import { render, staticRenderFns } from "./comentariosForm.vue?vue&type=template&id=ef1fea1a&scoped=true&"
import script from "./comentariosForm.vue?vue&type=script&lang=js&"
export * from "./comentariosForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef1fea1a",
  null
  
)

export default component.exports